import { IonContent, IonInput, IonPage, IonText,IonSpinner } from "@ionic/react";
import moment from "moment";
import { useEffect, useState,useMemo } from "react";
import { useHistory, useLocation } from "react-router";
import { Modal } from "react-bootstrap";
import DataTable from "react-data-table-component";
import service from "../../Service/service";
import Head from "../Header";
import Sidebar from "../Sidebar";
import swal from 'sweetalert';

const ProjectReportView: React.FC = (props) => {
    const history = useHistory();
    const location: any = useLocation();
    const [data, setdata] = useState([])
    const [activitydata, setactivitydata] = useState([])
    const [isLoading,setisLoading]=useState(false)
    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [token] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {

        if (token === null) {
            history.push("/login");
        } else {
        }
    }, [token, history]);
    const [selectedProject, setSelectedProject] = useState("");
    const [prjresource, setprjresource] = useState<number>(0); // Set the initial value as a number
    const [activity, setactivity] = useState<number>(0);
    const [showActivityInput, setShowActivityInput] = useState(false);
    const [showActivityViewTable, setShowActivityViewTable] = useState(false);
    const projectId = location.state?.projectId;
    const projectName = location.state?.projectName;
    const [showActivityProjectSelect, setShowActivityProjectSelect] = useState(false);
    const Id = (location.state?.id);

    const handleProjectChange = (e: any) => {
        const selectedValue = e.target.value;
        if (selectedValue === "1") {
            setactivity(0);
            setShowActivityProjectSelect(false);
            setShowActivityViewTable(false);
            setdata([])
            setactivitydata([]);
        } else if (selectedValue === "2") {
            setprjresource(2);
            setactivity(1);
            setShowActivityProjectSelect(true);
            setShowActivityViewTable(true);
            setdata([])
            setactivitydata([])
        } else {
            setprjresource(0);
            setactivity(0);
            setShowActivityProjectSelect(false);
            setShowActivityViewTable(false);
            setdata([])
            setactivitydata([]);
        }
    };


    // const Empresources = () => {
       
    //     if (projectId) {
    //         service.ProjectReport(projectId, prjresource, activity)
    //             .then((response) => {
    //                 console.log("Employee");
    //                 console.log(response);
    //                 if (response.data.status === "200") {
    //                     setdata(response.data.data)
    //                     setactivitydata(response.data.data)
    //                 }
                  
    //                 else {
    //                     swal("", response.data.message, "error");
    //                 }
    //             });
    //     } else {
    //         console.log("Project ID not available");
    //     }
    // };
    const Empresources = () => {
        if (projectId) {
            service.ProjectReport(projectId, prjresource, activity)
                .then((response) => {
                    console.log("Employee");
                    console.log(response);
                    if (response.data.status === "200") {
                        setdata(response.data.data)
                        setactivitydata(response.data.data)
                    } else if (!response.data.data || response.data.data.length === 0) {
                       
                        swal("","No effort has been logged under this project…", "info");
                    } else {
                        swal("", response.data.message, "error");
                    }
                })
                .catch((error) => {
                   
                    console.error("Error:", error);
                    swal("Error", "An error occurred", "error");
                });
        } else {
            console.log("Project ID not available");
        }
    };
    
//-------------------Pdf Api---------------------------//

    const EmpResourcesPdf = () => {
        setisLoading(true);
        setTimeout(() => {
          if (!prjresource) {
            setisLoading(false); 
            swal("Select Report Options", "Please select a report option before generate a pdf.", "error");
            return;
          }
          if (projectId) {
            service.ProjectReportPdf(projectId, prjresource, activity)
              .then((response) => {
                console.log("Employee");
                console.log(response);
                if (response.status === 200) {
                  setdata(response.data);
                  setactivitydata(response.data);
                } else {
                  swal("", response.data.message, "error");
                }
              })
              .finally(() => {
                setisLoading(false); // Stop loading whether success or error
              });
          } else {
            setisLoading(false); // Stop loading
            console.log("Project ID not available");
          }
        }, 1500);
      };
      
//--------------Search filter----------------------//
   //-----------(ProjectActivity)-------------//
const activitydata1 = data.filter(
    (item: any) =>
        JSON.stringify(item)
            .toLowerCase()
            .indexOf(filterText.toLowerCase()) !== -1
);
//-----------(ProjectResources)-------------//
const data1 = data.filter(
    (item: any) =>
        JSON.stringify(item)
            .toLowerCase()
            .indexOf(filterText.toLowerCase()) !== -1
);
const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: "ALL"
};
const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
        if (filterText) {
            setResetPaginationToggle(!resetPaginationToggle);
            setFilterText("");
        }
    
    };

return (
    <div style={{ display: "flex" }}>
        <div style={{ display: "flex" }}>
            <div className="form-group form-focus row">
                <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                    value={filterText} placeholder="Search" />
                <label className="focus-label">Search</label>
            </div>
            <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
        </div>
    </div>
)

}, [filterText, resetPaginationToggle]);

//------------Project Resouces Datatable------------------//

    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => i + 1,
            sortable: true,
            // width: "178px"
        },
        {
            name: "Employee Name",
            selector: (itm: any) => itm.empName,
            sortable: true,
            sort: "empName",
            cell: (itm: any) => (
                <>
                    <div>{itm.empName}{" ("}{itm.empCode}{")"}</div>
                </>
            )
        },
        {
            name: "Effort This Month",
            // width: "350px",
            selector: (itm: any) => itm.effortThisMonth,
            sortable: true,

        },
        {
            name: "Effort Till Date",
            // width: "350px",
            sortable: true,
            selector: (item: any) => item.effortTillDate,
        },
    ];

//------------------Activity Datatable----------------//

    const Activityviewtable: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => i + 1,
            sortable: true,
            // width: "178px"
        },
        {
            name: "Activity",
            selector: (itm: any) => itm.activity,
            width: "350px",
            sortable: true,
            sort: "activity",
            cell: (itm: any) => {
                if (itm.activity !== null && itm.activity !== undefined) {
                    return itm.activity;
                } else {
                    return 'NULL';
                }
            },
        },
        {
            name: "Effort This Month",
            // width: "350px",
            selector: (itm: any) => itm.effortThisMonth,
            sort: "effortThisMonth",
            sortable: true,

        },
        {
            name: "Effort Till Date",
            // width: "350px",
            sortable: true,
            selector: (item: any) => item.effortTillDate,
        }
    ];

    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px",
                padding: "0px",
                justifyContent: "center"
            },
        },
        row: {
            style: {
            }
        },
        cells: {
            style: {
                fontSize: "16px",
                justifyContent: "center",
                padding: "0px"
            }
        }
    };
    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                        Project Report - <span style={{ fontWeight: "normal" }}>{projectName}</span>
                                    </h3>

                                </div>
                            </div>
                            <div className="row filter-row" style={{ marginTop: "3%" }}>
                                <div className="col-sm-6 col-md-3">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Select Report Options <span className="text-danger">*</span></label>
                                        <div>
                                            <select style={{
                                                backgroundColor: '#ffffff',
                                                color: '#000000',
                                            }} className="select" onChange={(e: any) => {
                                                handleProjectChange(e);
                                                setprjresource(e.target.value);

                                            }
                                            }>
                                                <option value="" disabled selected>Select Options</option>

                                                <option value='1'> Project Resources Wise Report</option>
                                                <option value='2'>Project Activity Wise Report</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {showActivityProjectSelect && ( 
                                    <div className="col-sm-6 col-md-3">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Activity</label>
                                            <div>
                                                <select className="select" onChange={(e: any) => setactivity(e.target.value)} style={{
                                                    backgroundColor: '#ffffff',
                                                    color: '#000000',
                                                }} >
                                                    <option value="" disabled selected>Select Activity Type</option>
                                                    <option value="1">Meta Activity</option>
                                                    <option value="2"> Project Activity Code</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="col-sm-6 col-md-3" style={{ display: "flex", alignSelf: "center", justifySelf: "center" }}>
                                    <a onClick={() => {
                                        Empresources();
                                    }} className="btn btn-orange btn-block w-100"> View Report </a>
                                </div>
                                <div className="col-sm-6 col-md-3 col-lg-3" style={{ display: 'flex', alignSelf: 'center', justifySelf: 'center' }}>
                                    <button

                                        className="btn btn-success btn-block w-100" onClick={EmpResourcesPdf}><i className="la la-file-pdf-o" />
                                        Generate pdf
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {isLoading && (
                <div
                  style={{
                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                  }}
                >
                  <div >
                    <IonSpinner style={{
                      width: "40px",
                      height: "40px",
                      color: "#ff8a53"
                    }} name="lines" />
                  </div>
                </div>
              )}
                    {data.length > 0 && (

                        <div className="table-responsive" style={{ marginTop: "1%", marginLeft: "1%" }}>
                            {showActivityViewTable && showActivityProjectSelect ? (
                                
                                <DataTable
                                    columns={Activityviewtable}
                                    data={activitydata1}
                                    pagination
                                    paginationPerPage={10}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    subHeader
                                    subHeaderComponent={subHeaderComponent}
                                    customStyles={customStyles}
                                />
                            ) : (
                                <DataTable
                                    columns={columns}
                                    data={data1}
                                    pagination
                                    paginationPerPage={10}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    subHeader
                                    subHeaderComponent={subHeaderComponent}
                                    customStyles={customStyles}
                                />
                            )}
                        </div>
                    )}
                </div>
            </IonContent>
        </IonPage>
    );
};

export default ProjectReportView;